import { useEffect } from "react";
import { useHistory } from "react-router";
import { CircularLoader } from "../atoms/Loaders";
import { programmes } from "../../enums/programmes";
import JourneyStates from "../../enums/journeyStates";
import Pathway from "../../enums/profile/Pathway";
import { getProgrammeBySlug, getJourneyBySlug } from "../../utils/JourneyUtils";
import { IsObjectEmptyOrNull } from "../../utils/IsEmpty";

export const useJourneyRouter = (authState, profile, programmeSlug) => {
  let history = useHistory();

  useEffect(() => {
    if (!authState.ready || (!authState.authenticated && !profile)) return;

    const journey = getJourneyBySlug(profile, programmeSlug);
    const selectedProgramme = getProgrammeBySlug(programmeSlug);

    if (IsObjectEmptyOrNull(journey)) {
      if (
        window.location.pathname.includes("/preview") ||
        window.location.pathname.includes("/followup-weight")
      ) {
        return;
      }
    }

    const isInReferralState = journey?.state === JourneyStates.REFERRAL;
    const step0Completed = journey?.flags?.step0Completed === true;
    const supportedUser = journey?.pathway === Pathway.SUPPORTED;
    const initialWeightLogged = journey?.flags?.initialWeightLogged === true;
    const appointmentBooked = journey?.flags?.appointmentBooked === true;

    // permanent programme specific flags
    const myProgress = selectedProgramme?.features?.myProgress === true;
    const bookAppointments = selectedProgramme?.features?.bookAppointments === true;

    if (authState.accountState === "EmailNotVerified") {
      return <CircularLoader />;
    }

    // 0 - SmokeFree programme: Redirect user to homePage when the user tries to access myProgress page via url
    if (journey?.programmeId === programmes["smoke-free"].id) {
      if (window.location.pathname.includes("/my-progress")) {
        history.push("/");
      }
    }

    if (programmeSlug && authState.accountState === "EmailVerified") {
      // FORCE PROFILE BUILDER
      // This means there is only one journey and needs to complete profile
      if (authState.referralSource === "SelfReferral" || authState.referralSource === "Crm") {
        if (!window.location.pathname.includes("/sign-up/profile-builder")) {
          history.push(`/sign-up/profile-builder/${programmeSlug}`);
        }
      } else {
        if (!window.location.pathname.includes("/profile-builder")) {
          history.push(`/profile-builder/${programmeSlug}`);
        }
      }
      return <CircularLoader />;
    }

    // 1 - FORCE STEP 0
    if (programmeSlug && !isInReferralState && !step0Completed) {
      if (
        !window.location.pathname.includes(`/my-path/${programmeSlug}/step-00`) &&
        !window.location.pathname.includes(`/my-path/${programmeSlug}/step-0/part-01`)
      ) {
        history.push(`/my-path/${programmeSlug}/step-00`);
      }
      return <CircularLoader />;
    }

    // 2 - FORCE MY PROGRESS
    if (programmeSlug && step0Completed && !initialWeightLogged && myProgress) {
      if (!window.location.pathname.includes("/my-progress")) {
        history.push(`/my-progress/${programmeSlug}`);
      }

      return <CircularLoader />;
    }

    // 3 - FORCE BOOK APPOINTMENT
    if (
      programmeSlug &&
      step0Completed &&
      supportedUser &&
      initialWeightLogged &&
      !appointmentBooked &&
      bookAppointments
    ) {
      if (!window.location.pathname.includes(`/book-appointment/${programmeSlug}`)) {
        history.push(`/book-appointment/${programmeSlug}`);
      }
      return <CircularLoader />;
    }

    // 4 - FORCE USER AWAY FROM BOOK APPOINTMENT WHEN ALREADY BOOKED
    if (window.location.pathname.includes(`/book-appointment/${programmeSlug}`)) {
      if (!supportedUser || !bookAppointments || appointmentBooked) {
        history.push("/");
      }
      return <CircularLoader />;
    }
  }, [
    authState.accountState,
    authState.authenticated,
    authState.referralSource,
    history,
    profile,
    programmeSlug,
  ]);
};
